import { clearAuthToken, hasStoredAuthToken } from "../api";

function nextParam(fallback?: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get("next") || fallback || "/conversas";
}

function loginHref(next?: string): string {
  const value = encodeURIComponent(nextParam(next));
  return `/login?next=${value}&reason=unauthorized`;
}

export function UnauthorizedPage({ next }: { next?: string }) {
  function goLogin() {
    clearAuthToken();
    window.location.href = loginHref(next);
  }

  return (
    <main class="status-shell">
      <section class="status-panel">
        <span class="status-code">401</span>
        <h1 class="status-title">Acesso não autorizado</h1>
        <p class="status-text">
          Faça login para acessar o dashboard ou use um link de conversa válido.
        </p>
        <button class="btn btn--primary" type="button" onClick={goLogin}>
          Ir para login
        </button>
      </section>
    </main>
  );
}

export function NotFoundPage(
  { title = "Página não encontrada", detail }: { title?: string; detail?: string | null },
) {
  const href = hasStoredAuthToken() ? "/conversas" : "/login?next=/conversas";
  return (
    <main class="status-shell">
      <section class="status-panel">
        <span class="status-code">404</span>
        <h1 class="status-title">{title}</h1>
        {detail && <p class="status-text">{detail}</p>}
        <a class="btn btn--primary" href={href}>
          Voltar
        </a>
      </section>
    </main>
  );
}

export function ErrorPage(
  { title = "Erro ao carregar", detail }: { title?: string; detail?: string | null },
) {
  return (
    <main class="status-shell">
      <section class="status-panel">
        <span class="status-code">Erro</span>
        <h1 class="status-title">{title}</h1>
        {detail && <p class="status-text">{detail}</p>}
        <a class="btn btn--primary" href="/conversas">
          Voltar
        </a>
      </section>
    </main>
  );
}
